module.exports = __webpack_public_path__ + "img/Forter.9b81420d.svg";